export * from "./UpdatePatient.async";
